import { useQuery } from '@tanstack/react-query'

import { useAppSelector } from 'common/hooks/redux'

import { CategoryProductsResponse, getCategoryProducts, Region } from '../api'
import { contentKeys } from '../queryKeys'

const useGetProductsQuery = ({
  catalogId,
  categoryId,
  region,
}: {
  catalogId: string | undefined
  categoryId: string | undefined
  region: Region | undefined
}) => {
  const accountId = useAppSelector((state) => state.authStates.accountId)

  const getProductsQuery = useQuery({
    queryKey: contentKeys.categoryProducts({
      accountId,
      catalogId,
      categoryId,
      region,
    }),

    queryFn: () =>
      getCategoryProducts({
        accountId,
        catalogId,
        categoryId,
        region,
      }),
    enabled: !!accountId && !!catalogId && !!categoryId && !!region,
    select: (data: CategoryProductsResponse) => {
      return data.items
    },
    retry: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    meta: {
      errorMessage: 'The item data could not be loaded',
    },
  })

  return getProductsQuery
}

export default useGetProductsQuery
